// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vuetify from '@/plugins/vuetify'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import myaxios from '@/assets/js/http.js'
import myaxiospay from '@/assets/js/httppay.js'
import 'babel-polyfill';
// import dataV from '@jiaminghi/data-view'
import qwaxios from '@/assets/js/qw-http.js'
import ERP from "./assets/lib/ERP";
import store from "./store"
import moment from 'moment'
// import Page from "./assets/lib/Page";
import VueAMap from "vue-amap";
import _ from 'lodash';

import Oss from '@/common/Oss.js';
import User from "./common/user/User.js"
import Socket from "./common/Socket.js";
// import RTC from "./common/RTC.js";

//引入公共样式
import './assets/css/app.scss';

// import VForm from 'vform-builds'  //引入VForm库
import 'element-ui/lib/theme-chalk/index.css'  //引入element-ui样式
// import 'vform-builds/dist/VFormDesigner.css'  //引入VForm样式


import vform from '../lib/vform/VFormDesigner.umd.js'
import '../lib/vform/VFormDesigner.css'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// 引入样式
import "vue-easytable/libs/theme-default/index.css";
// 引入组件库
import VueEasytable from "vue-easytable";
import {VeLocale} from "vue-easytable";
// 引入英文语言包
import zhCN from "vue-easytable/libs/locale/lang/zh-CN.js";

import MVFormDesigner from '../lib/m-lib/MVFormDesigner.umd.js'
import '../lib/m-lib/MVFormDesigner.css'
import Logger from "./common/logger/Logger";
import LogController from "./common/logger/LogController";
import FunctionRegister from "./common/FunctionRegister";
import "./common/VueDirective.js";

// import 'intro.js/introjs.css';
// import introJs from 'intro.js';

//Vue.config.productionTip = false
Vue.use(FunctionRegister);
Vue.use(VueEasytable);
VeLocale.use(zhCN)
// Vue.use(dataV)
Vue.use(myaxios);
Vue.use(myaxiospay);
Vue.use(iView)
Vue.use(qwaxios);
Vue.use(ElementUI,{ size: 'small', zIndex: 3000 });
Vue.use(VueAMap);
Vue.use(Oss);
Vue.prototype._ = _;
// Vue.prototype.$introJs=(elem=null)=>{
//   let introOption= {
//     // 参数对象
//     prevLabel: "上一步",
//     nextLabel: "下一步",
//     skipLabel: "跳过",
//     doneLabel: "完成",
//     tooltipClass: "intro-tooltip" /* 引导说明文本框的样式 */,
//     // highlightClass: 'intro-highlight', /* 说明高亮区域的样式 */
//     exitOnEsc: true /* 是否使用键盘Esc退出 */,
//     exitOnOverlayClick: false /* 是否允许点击空白处退出 */,
//     keyboardNavigation: true /* 是否允许键盘来操作 */,
//     showBullets: false /* 是否使用点显示进度 */,
//     showProgress: false /* 是否显示进度条 */,
//     scrollToElement: true /* 是否滑动到高亮的区域 */,
//     skipHighlight: true,
//     overlayOpacity: 0.5, // 遮罩层的透明度 0-1之间
//     positionPrecedence: [
//       "bottom",
//       "top",
//       "right",
//       "left",
//     ] /* 当位置选择自动的时候，位置排列的优先级 */,
//     disableInteraction: false /* 是否禁止与元素的相互关联 */,
//     hidePrev: true /* 是否在第一步隐藏上一步 */,
//     hideNext: false /* 是否在最后一步隐藏下一步 */,
//     steps: [] /* steps步骤，可以写个工具类保存起来 */,
//   };
//   return introJs(elem).setOptions(introOption);
// };
Vue.config.productionTip = false;

Vue.use(MVFormDesigner)
Vue.use(vform)

Vue.filter('dateFormat', (str, partten = "YYYY-MM-DD HH:mm:ss") => {
  return moment(str).format(partten);
})

VueAMap.initAMapApiLoader({
  key: '',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', "AMap.Geocoder", "AMap.Geolocation","AMap.AMapUI"],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

//挂载全局ERP总控
window.ERP=ERP;
ERP.initAPP();
ERP.vuetifyPage(router);

Logger.push()
LogController.onPage(router)

// Page.initPage()

//挂载ERP在进入Vue上
Vue.prototype.ERP=ERP
Vue.prototype.isPermission=ERP.isPermission

/**
 * 挂载全局User
 * @type {User}
 */
Vue.prototype.$auth=User.getInstance();
Vue.prototype.$socket={
  Socket:Socket,
  socket:Socket.getInstance(),
};
// Vue.prototype.$RTC=RTC;
// Vue.prototype.$rtc=RTC.getInstance();

//全局参数配置
ERP.setStore("__TABLE_HEIGHT__",window.innerHeight-400);//表格高度控制
window.onresize=function () {
  ERP.setStore("__TABLE_HEIGHT__",window.innerHeight-400);//表格高度控制
}

window.__MENU_LIST__=[];


/* eslint-disable no-new */
//挂载全局__ERP__
window.__ERP__=new Vue({
  el: '#app',
  router,
  vuetify,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js